import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { ProductImage, primaryImageId } from "../components/ProductImage";
import { strengthsLabel, priceLabel } from "../lib/product";
import { Watermark, Eyebrow } from "../components/Botanical";

export default function Skincare() {
  const [products, setProducts] = useState(null);

  useEffect(() => {
    api.get("/products", { params: { category: "skincare" } }).then((r) => setProducts(r.data || [])).catch(() => setProducts([]));
  }, []);

  return (
    <div className="relative overflow-x-clip" data-testid="skincare-wrap">
    <Watermark opacity={0.7} flip height="h-[230px] sm:h-[260px]" testid="skincare-watermark" />
    <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-16" data-testid="skincare-page">
      <div className="mb-12 max-w-xl">
        <Eyebrow>Skincare</Eyebrow>
        <h1 className="font-serif text-5xl mt-2">Skin Booster Serums</h1>
        <p className="text-sm text-[#5E4D5A] mt-3 leading-relaxed">Topical cosmetic serums from Kind of Crunchy Moms.</p>
      </div>

      {products && products.length === 0 && (
        <div className="relative overflow-hidden text-center py-20 border border-dashed border-[#C99898] rounded-2xl text-[#5E4D5A]" data-testid="skincare-empty">
          <span className="relative">Our serums are coming soon.</span>
        </div>
      )}

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {(products || []).map((p) => (
          <Link key={p.id} to={`/skincare/${p.id}`} data-testid={`skincare-card-${p.id}`} className="bg-white rounded-2xl border border-[#C99898]/25 overflow-hidden hover:shadow-md hover:-translate-y-0.5 transition-transform transition-shadow duration-300 group">
            <ProductImage imageId={primaryImageId(p)} alt={p.name} iconSize={72} testId={`skincare-card-image-${p.id}`} />
            <div className="p-6">
              <h3 className="font-serif text-xl leading-tight group-hover:text-[#59394F] transition-colors">{p.name}</h3>
              <p className="text-xs text-[#5E4D5A] mt-1">{strengthsLabel(p)}</p>
              <p className="mt-4 text-base font-medium" data-testid={`skincare-price-${p.id}`}>{priceLabel(p)}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
    </div>
  );
}
